import posthog, { posthogEnabled } from './posthog'

type LogAttributes = Record<string, string | number | boolean>

/** Emits only purpose-written, structured application logs to PostHog. */
export const posthogLogs = {
  info(message: string, attributes: LogAttributes) {
    if (posthogEnabled) posthog.logger.info(message, attributes)
  },
  warn(message: string, attributes: LogAttributes) {
    if (posthogEnabled) posthog.logger.warn(message, attributes)
  },
  error(message: string, attributes: LogAttributes) {
    if (posthogEnabled) posthog.logger.error(message, attributes)
  },
}
